import React from 'react';
import { addDaysToLADateKey } from '../../utils/laDateUtils';
import DatePicker from '../shared/DatePicker';

/** Create-mode date range picker for ParticipantBookingPanel, bounded to the stay period. */
const BookingDateRangePicker = ({ fromKey, toKey, stayInKey, stayOutKey, onFromChange, onToChange }) => (
  <div className="pbt-daterange-group">
    <div className="pbt-daterange-group__field">
      <label className="pbt-label" htmlFor="pbt-check-in">Check in</label>
      <div className="pbt-date-input-wrap">
        <DatePicker
          id="pbt-check-in"
          className="pbt-date-input"
          value={fromKey}
          min={stayInKey}
          max={stayOutKey ? addDaysToLADateKey(stayOutKey, -1) : undefined}
          onChange={(e) => onFromChange(e.target.value)}
        />
      </div>
    </div>
    <div className="pbt-daterange-group__divider" aria-hidden="true">→</div>
    <div className="pbt-daterange-group__field">
      <label className="pbt-label" htmlFor="pbt-check-out">To</label>
      <div className="pbt-date-input-wrap">
        <DatePicker
          id="pbt-check-out"
          className="pbt-date-input"
          value={toKey}
          min={fromKey ? addDaysToLADateKey(fromKey, 1) : undefined}
          max={stayOutKey}
          onChange={(e) => onToChange(e.target.value)}
        />
      </div>
    </div>
  </div>
);

export default BookingDateRangePicker;
